module.exports = __webpack_public_path__ + "assets/T3_Point.e693549a2ff76ebdd05ebdee20f4faed.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/T3_Point.gmt
// module id = 1007
// module chunks = 0